import React from 'react';
import Account from './Account';
import CodingTestScreen from './CodingTestScreen';
import Profile from './Profile';
import Screen from './Screen';
import Protected from '../components/Protected';
import { Routes, Route, Navigate } from 'react-router-dom';
import Header from '../Header';
import { Dashboard } from './Admin/Dashboard';
import { CandidateAllTest } from './Admin/CandidateAllTest';
import { TestDetails } from './Admin/TestDetails';
import { AdminLogin } from './Admin/AdminLogin';
import { ProfileVerify } from './ProfileVerify';
import { CompleteProfile } from './CompleteProfile';
import Disconnectpage from './Disconnectpage';
import DownloadPage from './DownloadPage';

const Layout = (props) => {
    return (
        <>
            <Header />

            <div className="main-wrapper">
                <div className="main-content">
                    <Routes>
                        {/* <Route path='/' element={<Signin />} /> */}
                        <Route path='/account' element={<Protected><Account /></Protected>} />
                        <Route path='/download' element={<Protected><DownloadPage /></Protected>} />
                        <Route path='/profile-verify' element={<Protected><ProfileVerify /></Protected>} />
                        <Route path='/codingtest' element={<Protected><CodingTestScreen /></Protected>} />
                        <Route path='/profile' element={<Protected><Profile /></Protected>} />
                        <Route path='/complete-profile' element={<Protected><CompleteProfile /></Protected>} />
                        <Route path='/screen' element={<Protected><Screen /></Protected>} />
                        <Route path='/disconnected' element={<Protected><Disconnectpage /></Protected>} />
                        <Route path='/admin-login' element={<Protected><AdminLogin /></Protected>} />
                        <Route path='/dashboard' element={<Protected><Dashboard /></Protected>} />
                        <Route path='/candidate-tests' element={<Protected><CandidateAllTest /></Protected>} />
                        <Route path='/test-details' element={<Protected><TestDetails /></Protected>} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </div>
            </div>
        </>
    );
};

export default Layout;


